<template>
  <v-container
    id="lista-informacoes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-card
      class="mx-auto"
      outlined
    >
      <v-list-item three-line>
        <v-list-item-content
          id="listItemListaUsuario"
          class="pr-10"
          :style="dynamicPaddingListaInformacoes"
        >
          <div class="text-overline mb-4 highlighted-item">
            Lista ícone informações
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-row>
          <v-col
            id="buscaInformacoes"
            cols="12"
            sm="4"
            md="4"
            lg="4"
          >
            <tex-field-with-validation
              v-model="informacoesSelect"
              label="Buscar Orientações ..."
              @keyup.enter="filtrarCodigo()"
            />
          </v-col>
          <v-col
            cols="12"
            sm="1"
            md="1"
            lg="1"
          >
            <v-btn
              id="btnBuscarInformacoes"
              small
              class="v-btn--block"
              :color="corPrimaria"
              @click="filtrarCodigo()"
            >
              Buscar
            </v-btn>
          </v-col>
        </v-row><br>
      </v-card-actions>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              v-if="loadingInformacoes"
              :style="styleObject"
              class="text-center"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando dados...
            </div>
            <div
              v-else-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div
              v-else
            >
              <v-data-table
                id="headers"
                :headers="headers"
                :items="exibirDadosFiltrados ? informacoesFiltros : informacoes"
                :page.sync="page"
                hide-default-footer
                disable-sort
                class="elevation-1"
                style="color: black"
                item-key="id"
              >
                <template v-slot:[`item.editarDescricao`]="{ item }">
                  <v-icon
                    class="text-h2"
                    :color="corPrimaria"
                    @click="editarOrientacao(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <template v-slot:[`item.descriacao`]="{ item }">
                  <div v-html="item.descriacao" />
                </template>
              </v-data-table>
              <br>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div class="d-flex justify-space-between align-center pa-2">
                    <v-pagination
                      v-model="page"
                      :length="exibirDadosFiltrados ? totalPaginasFiltro: totalPaginas"
                      :total-visible="exibirDadosFiltrados ? totalPaginasFiltro: totalPaginas"
                      @input="onPageChange"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template>
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="1500px"
        content-class="custom-dialog-content-informacoes"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h4>{{ dialog.message }}</h4>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            style="white-space: pre-line"
          >
            <v-container>
              <v-text-field
                v-model="dialog.orientacao.codigo"
                label="Código"
                disabled
              />
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <div class="horizontal-scroll">
                    <v-textarea
                      v-model="dialog.orientacao.descriacao"
                      label="Descrição"
                      rows="5"
                      auto-grow
                      @focus="abrirTexto"
                      @blur="fecharTexto"
                    />
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="enableTexto"
                    id="textoExibicao"
                    class="text-justify"
                    v-html="dialog.orientacao.descriacao"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-row justify="center">
              <v-col
                cols="4"
                lg="2"
              >
                <v-btn
                  id="btnRefazer"
                  class="pa-2 ma-2"
                  small
                  :color="corPrimaria"
                  dark
                  @click="dialog.visible = false, excluirPagina = true"
                >
                  Fechar
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                lg="2"
              >
                <v-btn
                  id="btnRefazer"
                  class="pa-2 ma-2"
                  small
                  :color="corPrimaria"
                  dark
                  @click="atualizarDescricao(dialog.orientacao)"
                >
                  <v-icon>
                    mdi-update
                  </v-icon>
                  Atualizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    >
      {{ snackbar.message }}
    </dashboard-core-snackbar>
  </v-container>
</template>

<script>
  import Menu from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageListaUsuarios',
    emits: ['enablePermissao', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      headers: [
        { text: 'Código', value: 'codigo', width: '10%', class: 'black--text title' },
        { text: 'Descrição', value: 'descriacao', width: '80%', align: 'left', class: 'black--text title' },
        { text: 'Editar ', value: 'editarDescricao', width: '10%', align: 'center', class: 'black--text title' },
      ],
      informacoes: [],
      paginaEnable: false,
      dialog: {
        visible: false,
        message: '',
        orientacao: [],
      },
      dialogVisible: false,
      dialog1: {
        descricao: '',
        visible: false,
      },
      enableTexto: false,
      dynamicPaddingListaInformacoes: '',
      informacoesSelect: '',
      exibirDadosFiltrados: false,
      informacoesFiltros: [],
      page: 1,
      pageFiltro: 1,
      totalPaginas: 0,
      totalPaginasFiltro: 0,
      loadingInformacoes: false,
      error: '',
    }),

    computed: {
      pageCount () {
        const lista = this.exibirDadosFiltrados
          ? this.informacoesFiltros
          : this.informacoes

        return Math.ceil(lista.length / this.itemsPerPage)
      },
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      eventEmit.$emit('atualizar_texto', 'Informações')

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      Menu.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.paginaEnable = true

          this.showListaInformacoes()
        } else {
          this.$router.push('/dashboard')
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingListaInformacoes = 'padding-right: 110rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingListaInformacoes = 'padding-right: 80rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingListaInformacoes = 'padding-right: 20rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
          this.dynamicPaddingListaInformacoes = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingListaInformacoes = 'padding-right: 70rem !important'
        }
      },

      abrirTexto () {
        this.enableTexto = true
      },

      fecharTexto () {
        this.enableTexto = false
      },

      async showListaInformacoes () {
        this.loadingInformacoes = true

        this.exibirDadosFiltrados = false

        this.informacoesFiltros = []

        this.informacoesSelect = ''

        await Menu.showInformacoes(localStorage.tokencontrato, this.page, this.informacoesSelect).then(resposta => {
          if (resposta.data.status) {
            this.informacoes = resposta.data.informacoes

            this.totalPaginas = resposta.data.totalPaginas
          } else {
            this.informacoes = []
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingInformacoes = false
        })
      },

      onPageChange () {
        if (this.informacoesSelect.length > 0) {
          this.buscarInformacoesFiltro()
        } else {
          this.showListaInformacoes()
        }
      },

      atualizarDescricao (item) {
        Menu.atualizarDescricao(item, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.dialog.visible = false

            this.showSnackbar('success', 3000, 'Descrição atualizada com sucesso!')
          } else {
            this.showSnackbar('error', 3000, 'Erro ao atualizar Descrição')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      editarOrientacao (item) {
        this.showModal(item)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showModal (item) {
        this.showDialog('Editar Orientação', item)
      },

      showDialog (message, orientacao) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.orientacao = orientacao
      },

      filtrarCodigo () {
        if (this.informacoesSelect.length > 0) {
          this.page = 1

          this.buscarInformacoesFiltro()
        } else {
          this.exibirDadosFiltrados = false

          this.totalPaginasFiltro = 1

          this.page = 1

          this.informacoesFiltros = []

          this.showListaInformacoes()
        }
      },

      async buscarInformacoesFiltro () {
        this.loadingInformacoes = true

        await Menu.showInformacoes(localStorage.tokencontrato, this.page, this.informacoesSelect).then(resposta => {
          if (resposta.data.status) {
            this.exibirDadosFiltrados = true

            this.informacoesFiltros = resposta.data.informacoes

            this.totalPaginasFiltro = resposta.data.totalPaginas
          } else {
            this.informacoesFiltros = []

            this.totalPaginasFiltro = 1
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingInformacoes = false
        })
      },
    },
  }
</script>

<style lang="sass">
  .horizontal-scroll
    overflow-x: auto
    white-space: nowrap

  #textoExibicao
    font-size: 12px

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemListaUsuario
    margin: -2rem 0 0 -1rem

  #buscaInformacoes
    margin: -1.5rem 0 0 1rem

  #btnRefazer
    width: 130px !important
    max-width: 130px !important
    min-width: 130px !important
    border-radius: 10px !important

  #btnBuscarInformacoes
    width: 130px !important
    max-width: 130px !important
    min-width: 130px !important
    border-radius: 10px !important

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
</style>
